import type { ButtonProps } from "@/components/ui/button"
import { Button } from "@/components/ui/button"
import { MouseEvent, useCallback } from "react"
import { useFormState } from "react-hook-form"

export function SubmitButton({
  disabled: disabledFromProps,
  onClick,
  ref,
  ...props
}: ButtonProps) {
  const { isSubmitting, errors, isValid } = useFormState()
  const amountOfErrors = Object.keys(errors).length
  const isFormValid = amountOfErrors === 0 && isValid

  const disabled = disabledFromProps || isSubmitting || !isFormValid

  const handleClick = useCallback(
    (domEvent: MouseEvent<HTMLButtonElement>) => {
      if (isSubmitting || disabled) {
        domEvent?.preventDefault()
      }

      // In ButtonBase we have set  '&[disabled] { pointer-events: none; }'
      // but just to be more resilient we add a check here.
      if (!disabled && typeof onClick === "function") {
        onClick(domEvent)
      }
    },
    [disabled, isSubmitting, onClick],
  )

  return (
    <Button
      ref={ref}
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      {...props}
    />
  )
}
